module.exports = __webpack_public_path__ + "img/ripples-choppy.5f6070a909fb15b49d5d9dd1f2b7ed53.jpg";